import Nav from "components/nav/Navbar";
import React from "react";
import { Game } from "./containers";

export default function EDGE_GAME() {
  return (
    <div>
      <Nav />

      <div className="py-4 sm:py-16">
        <Game boardSize={11} playerSize={25} />
      </div>
    </div>
  );
}
